/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { request as __request } from '../core/request';

export class SignalRService {
  /**
   * @returns any Default Response
   * @throws ApiError
   */
  public static async signalRSubscribeProcess({
    requestBody,
  }: {
    requestBody?: {
      storeCode: string;
      process: string;
      userId: string;
    };
  }): Promise<any> {
    const result = await __request({
      method: 'POST',
      path: `/api/v1/signalr_process_subscribe`,
      body: requestBody,
    });
    return result.body;
  }

  /**
   * @returns any Default Response
   * @throws ApiError
   */
  public static async signalRUnSubscribeProcess({
    requestBody,
  }: {
    requestBody?: {
      storeCode: string;
      process: string;
      userId: string;
    };
  }): Promise<any> {
    const result = await __request({
      method: 'POST',
      path: `/api/v1/signalr_process_unsubscribe`,
      body: requestBody,
    });
    return result.body;
  }

  /**
   * @returns any Default Response
   * @throws ApiError
   */
  public static async signalRUpdateStore({
    requestBody,
  }: {
    requestBody?: any;
  }): Promise<any> {
    const result = await __request({
      method: 'POST',
      path: `/api/v1/signalr_process_update`,
      body: requestBody,
    });
    return result.body;
  }

  /**
   * @returns any Default Response
   * @throws ApiError
   */
  public static async sirnalRStatus({
    store,
    process,
  }: {
    /** Store code identifier **/
    store: string;
    /** Process type identifier **/
    process: string;
  }): Promise<any> {
    const result = await __request({
      method: 'GET',
      path: `/api/v1/signalr_status/${store}/${process}`,
    });
    return result.body;
  }
}
